$("document").ready(function(){
    if(window.location.pathname.includes('/products/')){ // to update delivery time on pdp
    console.log('product_page');
    var $forward_d = $(".product-info").find(".product-info__liquid").find('span');
    var w_content = $forward_d.html()?.split('|');
    
    if( w_content?.length >= 2){
    // get content and extract days using regex
    var content = w_content[0];
    var daysMatch = w_content[1].match(/\d+/); // Extract the number from the second part
    var afterText = w_content[1].replace(/\d+/, '').trim(); // Capture text after the number
    
    if (daysMatch) {
    var days = parseInt(daysMatch[0]);
    const d = new Date();
    // set future date
    d.setDate(d.getDate() + days);
    const options = {
    weekday: "long",
    month: "long",
    day: "numeric"
    };
    // set the date format we want
    var d_date = new Intl.DateTimeFormat("en-US", options).format(d);
    // push the changes with the after text on a new line
    $forward_d.html(content + ' ' + d_date + afterText);
    }
    }
    }
    
    /*
    ----------------------------------------------------------------------------
    Fallback variant handling for product page
    ----------------------------------------------------------------------------
    In some cases the theme's built–in <variant-picker> logic may not correctly
    sync the selected options with the product form "id" input. The snippet
    below ensures that, whenever a customer selects a variant option, the
    corresponding variant ID is written into the product form so the correct
    variant is added to cart.
    */
    
    if (window.location.pathname.indexOf('/products/') !== -1) {
    setupVariantFallback();
    }
    
    function setupVariantFallback() {
    var variantsCache = {};
    var lastVariantByForm = {};
    
    function dispatchVariantChange(formEl, formId, variant) {
    if (!formEl || !formId || !variant) return;
    
    // Build a variant object compatible with theme listeners
    var safeVariant = Object.assign({}, variant);
    
    // Ensure featured_media exists for gallery logic (map from featured_image if needed)
    if (!safeVariant.featured_media && safeVariant.featured_image) {
    safeVariant.featured_media = {
    id: safeVariant.featured_image.id,
    position: safeVariant.featured_image.position
    };
    }
    
    var previousVariant = lastVariantByForm[formId] !== undefined ? lastVariantByForm[formId] : null;
    lastVariantByForm[formId] = safeVariant;
    
    try {
    formEl.dispatchEvent(new CustomEvent('variant:change', {
    bubbles: true,
    detail: {
    formId: formId,
    variant: safeVariant,
    previousVariant: previousVariant
    }
    }));
    } catch (e) {}
    
    // Hard-sync all galleries bound to this form, in case some listeners
    // are not attached (especially on mobile / quick-add contexts)
    try {
    if (safeVariant.featured_media && typeof safeVariant.featured_media.position === 'number') {
    var newIndex = safeVariant.featured_media.position - 1;
    if (newIndex < 0) newIndex = 0;
    
    var galleries = document.querySelectorAll('product-gallery[form="' + formId + '"]');
    galleries.forEach(function(galleryEl) {
    var carousel = galleryEl.querySelector('media-carousel.product-gallery__media-list');
    if (!carousel) return;
    if (typeof carousel.select === 'function') {
    carousel.select(newIndex, { animate: false });
    }
    });
    }
    } catch (e) {}
    }
    
    function loadVariants(handle) {
    if (!variantsCache[handle]) {
    variantsCache[handle] = fetch('/products/' + handle + '.js')
    .then(function(res) { return res.json(); })
    .then(function(product) { return product.variants || []; })
    .catch(function() { return []; });
    }
    return variantsCache[handle];
    }
    
    // Global listener so it also works after sections are re-rendered
    document.addEventListener('change', function(event) {
    var target = event.target;
    
    // Custom "Pick Your Size" radios (Green Burner etc.)
    if (target.classList && target.classList.contains('tsw-pick-size__radio')) {
    var formIdForRadio = target.getAttribute('data-form-id');
    var handleForRadio = target.getAttribute('data-handle');
    var variantId = parseInt(target.value, 10);
    
    if (!formIdForRadio || !handleForRadio || !variantId) {
    return;
    }
    
    loadVariants(handleForRadio).then(function(variants) {
    if (!variants.length) return;
    
    var matchedVariant = variants.find(function(v) { return v.id === variantId; });
    if (!matchedVariant) return;
    
    // Update all product forms for this form id
    var forms = document.querySelectorAll('form[is="product-form"][id="' + formIdForRadio + '"]');
    forms.forEach(function(formEl) {
    var idInput = formEl.querySelector('input[name="id"]');
    if (idInput) {
    idInput.disabled = false;
    idInput.value = matchedVariant.id;
    }
    
    try {
    dispatchVariantChange(formEl, formIdForRadio, matchedVariant);
    } catch (e) {}
    });
    
    // Update main price + compare-at visibility
    try {
    var priceElement = document.querySelector('price-list sale-price');
    if (priceElement && typeof matchedVariant.price === 'number') {
    var amount = (matchedVariant.price / 100).toLocaleString('en-IN', {
    style: 'currency',
    currency: Shopify.currency && Shopify.currency.active || 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
    }).replace('INR', '₹').replace(/\s/g, '');
    priceElement.textContent = amount;
    }
    
    var compareElement = document.querySelector('price-list compare-at-price');
    if (compareElement) {
    // Hide if compare_at_price doesn't exist, is 0 or less, or is not greater than current price
    if (!matchedVariant.compare_at_price || matchedVariant.compare_at_price <= 0 || matchedVariant.compare_at_price <= matchedVariant.price) {
    compareElement.setAttribute('hidden', 'hidden');
    } else {
    compareElement.removeAttribute('hidden');
    // Update compare-at-price text content
    var compareAmount = (matchedVariant.compare_at_price / 100).toLocaleString('en-IN', {
    style: 'currency',
    currency: Shopify.currency && Shopify.currency.active || 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
    }).replace('INR', '₹').replace(/\s/g, '');
    // Find and update the price span, or update textContent while preserving sr-only span
    var priceSpan = compareElement.querySelector('span.money');
    var srOnly = compareElement.querySelector('span.sr-only');
    if (priceSpan) {
    priceSpan.textContent = compareAmount;
    } else if (srOnly) {
    // Preserve sr-only span and update the price text
    compareElement.innerHTML = srOnly.outerHTML + '\n\n      ' + compareAmount;
    } else {
    compareElement.textContent = compareAmount;
    }
    }
    }
    // Also toggle discount badge based purely on compare_at vs price
    // Check variant compare_at_price first, then fallback to compare-at-price element value
    try {
    var discountEl = document.querySelector('price-list .discount-tile');
    var compareEl = document.querySelector('price-list compare-at-price');
    
    if (discountEl) {
    var comparePrice = null;
    var currentPrice = matchedVariant.price;
    
    // First try variant compare_at_price
    if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > 0 && matchedVariant.compare_at_price > currentPrice) {
    comparePrice = matchedVariant.compare_at_price;
    } else if (compareEl && !compareEl.hasAttribute('hidden')) {
    // Fallback: try to get compare price from the compare-at-price element
    var compareText = compareEl.textContent.trim();
    if (compareText) {
    // Extract price from text (e.g., "₹798" -> 79800 in cents)
    var priceMatch = compareText.match(/[\d,]+/);
    if (priceMatch) {
    var priceStr = priceMatch[0].replace(/,/g, '');
    var priceNum = parseInt(priceStr, 10);
    // If price is in rupees (not cents), convert to cents
    if (priceNum < 10000) {
    priceNum = priceNum * 100;
    }
    if (priceNum > currentPrice) {
    comparePrice = priceNum;
    }
    }
    }
    }
    
    if (comparePrice && comparePrice > currentPrice) {
    var pct = Math.round((comparePrice - currentPrice) * 100 / comparePrice);
    discountEl.textContent = pct + '% OFF';
    discountEl.style.display = '';
    } else {
    discountEl.style.display = 'none';
    }
    }
    } catch (e) {}
    } catch (e) {}
    });
    
    return;
    }
    
    // Standard Shopify option inputs
    if (!target.name || target.name.indexOf('option') !== 0) return;
    
    var formId = target.getAttribute('form');
    if (!formId) return;
    
    var picker = document.querySelector('variant-picker[form-id="' + formId + '"]');
    if (!picker) return;
    
    var handle = picker.getAttribute('handle');
    if (!handle) return;
    
    loadVariants(handle).then(function(variants) {
    if (!variants.length) return;
    
    // Read currently selected options for this picker/form id
    var optionInputs = Array.prototype.slice.call(
    document.querySelectorAll('input[name^="option"][form="' + formId + '"]:checked')
    ).sort(function(a, b) {
    var pa = parseInt(a.getAttribute('data-option-position') || '0', 10);
    var pb = parseInt(b.getAttribute('data-option-position') || '0', 10);
    return pa - pb;
    });
    
    if (!optionInputs.length) return;
    
    var selectedOptions = optionInputs.map(function(el) { return el.value; });
    
    var matched = variants.find(function(v) {
    return (!selectedOptions[0] || v.option1 === selectedOptions[0]) &&
    (!selectedOptions[1] || v.option2 === selectedOptions[1]) &&
    (!selectedOptions[2] || v.option3 === selectedOptions[2]);
    });
    
    if (!matched) return;
    
    // Ensure correct variant ID is used when adding to cart and notify theme listeners
    var forms = document.querySelectorAll('form[is="product-form"][id="' + formId + '"]');
    forms.forEach(function(formEl) {
    var idInput = formEl.querySelector('input[name="id"]');
    if (idInput) {
    idInput.disabled = false;
    idInput.value = matched.id;
    }
    
    // Fire variant:change so components like gallery, inventory, etc. can react
    try {
    dispatchVariantChange(formEl, formId, matched);
    } catch (e) {}
    });
    
    // Update visible "Size" text (variant-option-value) if present
    try {
    var optionValueDisplay = picker.querySelector('variant-option-value');
    if (optionValueDisplay && selectedOptions.length) {
    optionValueDisplay.textContent = selectedOptions[0];
    }
    } catch (e) {}
    
    // Update price on page using matched variant price if possible
    try {
    var priceElement = document.querySelector('price-list sale-price');
    if (priceElement && typeof matched.price === 'number') {
    // Shopify variant price is in cents/paise; divide by 100
    var amount = (matched.price / 100).toLocaleString('en-IN', {
    style: 'currency',
    currency: Shopify.currency && Shopify.currency.active || 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
    }).replace('INR', '₹').replace(/\s/g, '');
    priceElement.textContent = amount;
    }
    
    // Hide/show compare-at price based on variant compare_at_price
    // Hide if compare_at_price doesn't exist, is 0 or less, or is not greater than current price
    var compareElement = document.querySelector('price-list compare-at-price');
    if (compareElement) {
    if (!matched.compare_at_price || matched.compare_at_price <= 0 || matched.compare_at_price <= matched.price) {
    compareElement.setAttribute('hidden', 'hidden');
    } else {
    compareElement.removeAttribute('hidden');
    // Update compare-at-price text content
    var compareAmount = (matched.compare_at_price / 100).toLocaleString('en-IN', {
    style: 'currency',
    currency: Shopify.currency && Shopify.currency.active || 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
    }).replace('INR', '₹').replace(/\s/g, '');
    // Find and update the price span, or update textContent while preserving sr-only span
    var priceSpan = compareElement.querySelector('span.money');
    var srOnly = compareElement.querySelector('span.sr-only');
    if (priceSpan) {
    priceSpan.textContent = compareAmount;
    } else if (srOnly) {
    // Preserve sr-only span and update the price text
    compareElement.innerHTML = srOnly.outerHTML + '\n\n      ' + compareAmount;
    } else {
    compareElement.textContent = compareAmount;
    }
    }
    }
    // Also toggle discount badge based purely on compare_at vs price
    // Check variant compare_at_price first, then fallback to compare-at-price element value
    try {
    var discountEl = document.querySelector('price-list .discount-tile');
    var compareEl = document.querySelector('price-list compare-at-price');
    
    if (discountEl) {
    var comparePrice = null;
    var currentPrice = matched.price;
    
    // First try variant compare_at_price
    if (matched.compare_at_price && matched.compare_at_price > 0 && matched.compare_at_price > currentPrice) {
    comparePrice = matched.compare_at_price;
    } else if (compareEl && !compareEl.hasAttribute('hidden')) {
    // Fallback: try to get compare price from the compare-at-price element
    var compareText = compareEl.textContent.trim();
    if (compareText) {
    // Extract price from text (e.g., "₹798" -> 79800 in cents)
    var priceMatch = compareText.match(/[\d,]+/);
    if (priceMatch) {
    var priceStr = priceMatch[0].replace(/,/g, '');
    var priceNum = parseInt(priceStr, 10);
    // If price is in rupees (not cents), convert to cents
    if (priceNum < 10000) {
    priceNum = priceNum * 100;
    }
    if (priceNum > currentPrice) {
    comparePrice = priceNum;
    }
    }
    }
    }
    
    if (comparePrice && comparePrice > currentPrice) {
    var pct = Math.round((comparePrice - currentPrice) * 100 / comparePrice);
    discountEl.textContent = pct + '% OFF';
    discountEl.style.display = '';
    } else {
    discountEl.style.display = 'none';
    }
    }
    } catch (e) {}
    } catch (e) {}
    });
    });
    }
    
    // Validate discount-tile on page load - ensure it only shows when compare_at_price exists
    // This fixes the issue where discount shows on initial load even when compare_at_price is not set
    if (window.location.pathname.indexOf('/products/') !== -1) {
    function validateDiscountTileOnLoad() {
    try {
    var discountEl = document.querySelector('price-list .discount-tile');
    var compareEl = document.querySelector('price-list compare-at-price');
    var salePriceEl = document.querySelector('price-list sale-price');
    
    if (discountEl) {
    // If compare-at-price is hidden or empty, hide discount-tile
    if (!compareEl || compareEl.hasAttribute('hidden') || !compareEl.textContent.trim()) {
    discountEl.style.display = 'none';
    return;
    }
    
    // Validate that compare price is actually greater than sale price
    var compareText = compareEl.textContent.trim();
    var saleText = salePriceEl ? salePriceEl.textContent.trim() : '';
    
    if (compareText && saleText) {
    // Extract numeric values
    var compareMatch = compareText.match(/[\d,]+/);
    var saleMatch = saleText.match(/[\d,]+/);
    
    if (compareMatch && saleMatch) {
    var comparePrice = parseInt(compareMatch[0].replace(/,/g, ''), 10);
    var salePrice = parseInt(saleMatch[0].replace(/,/g, ''), 10);
    
    // Convert to cents if needed (prices less than 10000 are likely in rupees)
    if (comparePrice < 10000) comparePrice = comparePrice * 100;
    if (salePrice < 10000) salePrice = salePrice * 100;
    
    // Only show discount if compare price > sale price
    if (comparePrice <= salePrice || comparePrice <= 0) {
    discountEl.style.display = 'none';
    }
    }
    }
    }
    } catch (e) {
    console.error('Error validating discount tile on load:', e);
    }
    }
    
    // Run on DOM ready
    if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', validateDiscountTileOnLoad);
    } else {
    validateDiscountTileOnLoad();
    }
    
    // Also run after a short delay to catch any dynamic updates
    setTimeout(validateDiscountTileOnLoad, 100);
    }
    
    // mega_menu sub_menu selection
    $("li.main_menu_cu").on("click", function(){
    let $child_mm = $(this).find("ul.sub_menu_cu");
    // check the sub_menu item exist
    if($child_mm.length > 0){
    $("li.main_menu_cu a span").css('color', '#161616');
    $(this).children("a").children("span").css('color', '#AB8744');
    $("ul.sub_menu_cu").hide();
    $(this).find("ul.sub_menu_cu").show();
    }
    });
    
    // product-card-boco ajax
    attachAtcAjaxEvents(); // fire once on page load
    
    // for sort list change event
    document.addEventListener("listbox:change", function(){
    setTimeout(function(){
    attachAtcAjaxEvents();
    //console.log(event.target.parentElement);
    //console.log('kevin');
    }, 1000);
    });
    
    document.addEventListener('click', function(event) {
    
    // for filter checkbox
    if( event.target.matches("input.checkbox") ) {
    if( event.target.parentElement.matches("div.checkbox-container")){
    setTimeout(function(){
    attachAtcAjaxEvents();
    //console.log(event.target.parentElement);
    }, 1000);
    }
    }
    
    // for removing individual filters
    if( event.target.matches("a.tap-area") ) {
    if( event.target.parentElement.matches("div.removable-facet") ){
    setTimeout(function(){
    attachAtcAjaxEvents();
    //console.log(event.target.parentElement);
    }, 1000);
    }
    }
    
    // for clear all
    if( event.target.matches("span.link") ) {
    if( event.target.parentElement.matches("a.facet-clear-all") ){
    setTimeout(function(){
    attachAtcAjaxEvents();
    //console.log(event.target.parentElement);
    }, 1000);
    }
    }
    
    // for view more
    if( event.target.matches("button#load-more-btn") ) {
    if( event.target.parentElement.matches("div.more-btn-div") ){
    setTimeout(function(){
    
    attachAtcAjaxEvents();
    //console.log(event.target.parentElement);
    }, 1000);
    }
    }
    
    });
    
    function attachAtcAjaxEvents() {
    
    
    $('.add_to_cart_form_cu').on('submit', function(event){
    
    // var rawDOMElement = $(this).get(0);
    // var eventObject = $._data(rawDOMElement, 'events');
    // if(eventObject != undefined && eventObject.submit != undefined) {
    // return false;
    // }
    
    // get data
    var $atc_btn = $(this).find(".add-to-cart-button");
    var $t = $(".header__cart-count").find(".count-bubble");
    //var $t_in = $(".cart-drawer__top").find(".count-bubble");
    
    
    // disable atc button and cart count
    $atc_btn.prop("disabled", true);
    $t.css("opacity", "0");
    //$t_in.css("opacity", "0");
    
    event.preventDefault(); // prevent default form submission
    $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $(this).serialize(),
    dataType: 'json',
    success: function() {
    
    var item_count;
    $.when(
    jQuery.getJSON('/cart.js', function(cart) {
    item_count = cart.item_count;
    let cartData = cart.items;
    document.dispatchEvent(new CustomEvent('cart:build' ,{
    bubbles: true
    }
    ));
    document.dispatchEvent(new CustomEvent('cart:refresh', {
    bubbles: true,
    detail: cartData
    }));
    
    // get cart drawer
    document.dispatchEvent(new CustomEvent('variant:add', {
    bubbles: true,
    }));
    })
    ).then(function(){
    
    setTimeout(function(){
    
    // update cart count + enable opacity + enable atc btn
    $t.html(item_count);
    $t.css("opacity", "1");
    //$t_in.css("opacity", "1");
    $atc_btn.prop("disabled", false);
    
    }, 2000);
    
    });
    },
    error: function(e) {
    // for further debugging
    console.log(e.responseJSON);
    
    // restore button and count
    $t.css("opacity", "1");
    //$t_in.css("opacity", "1");
    $atc_btn.prop("disabled", false);
    }
    });
    
    });
    }
    
    $(".see-more").on("click", function(event) {
    const textContainer = document.querySelector('.text-container');
    const textContent = document.querySelector('.text-content');
    const seeMore = document.querySelector('.see-more');
    
    if (seeMore.textContent === "...read more") {
    textContent.style.display = 'block';
    textContent.style.webkitBoxOrient = 'unset';
    textContent.style.webkitLineClamp = 'unset';
    textContent.style.maxHeight = 'none';
    // seeMore.textContent = "read less";
    seeMore.style.display = 'none';
    }
    // else {
    // textContent.style.webkitBoxOrient = 'vertical';
    // textContent.style.webkitLineClamp = 2;
    // textContent.style.maxHeight = '46px';
    // seeMore.textContent = "...read more";
    // }
    });
    
    
    if(window.location.pathname.includes('/products/')){
    var descr_cont = $(".product-info").find(".product-info__description").find(".text-content").text().length;
    
    // if (window.innerWidth > 1000) {
    // Check if the text length is below 200 characters
    if (descr_cont < 200) {
    // Apply some CSS
    $('.see-more').css({
    'display': 'none'
    });
    $('.text-content').css({
    '-webkit-line-clamp': 'unset',
    'max-height': 'unset'
    });
    }
    // }
    
    // TSW mobile accordions: allow only one open at a time
    var $accordions = $('.tsw-mobile-accordions-block .tsw-mobile-accordion');
    if ($accordions.length) {
    var $summaries = $accordions.find('.tsw-mobile-accordion__toggle');
    
    $summaries.on('click', function (e) {
    e.preventDefault();
    
    var details = this.parentNode; // summary parent <details>
    var isOpen = details.hasAttribute('open');
    
    // Close all
    $accordions.each(function () {
    this.removeAttribute('open');
    });
    
    // Re-open current if it was previously closed
    if (!isOpen) {
    details.setAttribute('open', 'open');
    }
    });
    }
    }
    
    });